import React from "react";
import {Button, message, Modal, Table} from "antd";
import {useHistory} from "react-router-dom/cjs/react-router-dom.min";

const WarningModal = ({isWarningModalOpen, setIsWarningModalOpen, warningModalData}) => {
    const history = useHistory();

    return (
        <Modal
            visible={isWarningModalOpen}
            okText="Devam Et"
            closable={false}
            maskClosable={false}
            keyboard={false}
            footer={[
                <Button
                    key="submit"
                    type="primary"
                    onClick={() => {
                        if (
                            !warningModalData?.skippedTransfers?.length > 0 ||
                            !warningModalData?.unreceivedShipments?.length > 0
                        ) {
                            history.push("/transfers?status=completed");
                            return;
                        }
                    }}
                >
                    Devam Et
                </Button>
            ]}
            width={800}
        >
            <h3>Transfer Oluşturuldu, Özet Bilgiler</h3>
            <Table
                dataSource={warningModalData?.createdTransfers}
                title={() => <h4>Oluşturulan Transferler</h4>}
                scroll={{x: "max-content"}}
            >
                <Table.Column title="Transfer Adı" dataIndex="transferName" key="transferName" />
                <Table.Column
                    title="İl"
                    dataIndex="plannedCourier"
                    key="plannedCourier"
                    render={(text, record) => record?.plannedCourier?.city}
                />
                <Table.Column
                    title="İlçe"
                    dataIndex="plannedCourier"
                    key="plannedCourier"
                    render={(text, record) => record?.plannedCourier?.district}
                />
                <Table.Column
                    title="Barkod Numarası"
                    dataIndex="shipments"
                    key="shipments"
                    render={(text, record) => (
                        <div style={{padding: "4px 0"}}>
                            {record?.shipments
                                ?.map(shipment => shipment?.externalShipmentId)
                                .join(", ")}
                        </div>
                    )}
                />
                <Table.Column
                    title="Vigo Barkod"
                    dataIndex="shipments"
                    key="shipments"
                    render={(text, record) => (
                        <div style={{padding: "4px 0"}}>
                            {record?.shipments
                                ?.map(shipment => shipment?.vigoBarcodeNumber)
                                .join(", ")}
                        </div>
                    )}
                />
                <Table.Column
                    title="Paket Sayısı"
                    dataIndex="shipments"
                    key="shipments"
                    render={(text, record) => (
                        <div style={{padding: "4px 0"}}>
                            {record?.shipments?.map(shipment => shipment?.count).join("- ")}
                        </div>
                    )}
                />
                <Table.Column title="Transfer Tipi" dataIndex="type" key="type" />
            </Table>
            <Table
                dataSource={warningModalData?.skippedTransfers}
                title={() => <h4>Tüm Paketleri Kayıp Olan Transferler</h4>}
                scroll={{x: "max-content"}}
            >
                <Table.Column
                    title="Barkod"
                    dataIndex="barcode"
                    key="barcode"
                    render={(text, record) => (
                        <div>
                            {record?.details?.missingBarcodes?.map(barcodeInfo => (
                                <p key={barcodeInfo?.barcode}>{barcodeInfo?.barcode}</p>
                            ))}
                        </div>
                    )}
                />
                <Table.Column
                    title="Vigo Barkod"
                    dataIndex="vigoBarcode"
                    key="vigoBarcode"
                    render={(text, record) => (
                        <p>
                            {record?.details?.missingBarcodes?.map(
                                barcodeInfo => barcodeInfo?.vigoBarcode
                            )}
                        </p>
                    )}
                />
            </Table>
        </Modal>
    );
};

export default WarningModal;
